// --- Helper: get timezone offset for an arbitrary IANA zone at a given UTC instant ---
// Returns minutes like Date.prototype.getTimezoneOffset (UTC - local)
function getTimeZoneOffset(date, timeZone) {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });

  const parts = dtf.formatToParts(date);
  const vals = {};
  for (const { type, value } of parts) {
    if (type !== "literal") vals[type] = value;
  }

  // These fields represent the *local* time in the given timeZone.
  const localAsUTC = Date.UTC(
    Number(vals.year),
    Number(vals.month) - 1,
    Number(vals.day),
    Number(vals.hour),
    Number(vals.minute),
    Number(vals.second || 0)
  );

  // UTC - local (in minutes), same sign convention as getTimezoneOffset
  return (date.getTime() - localAsUTC) / 60000;
}

// --- Helper: Parse "MM/DD/YYYY HH:mm" as PACIFIC LOCAL and convert to UTC Date ---
function parseDateString(dateStr) {
  if (!dateStr) return null;

  const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/;
  const match = dateStr.match(regex);
  if (!match) return null;

  const [, m, d, y, h = "0", min = "0"] = match;
  const year = Number(y);
  const month = Number(m);
  const day = Number(d);
  const hours = Number(h);
  const minutes = Number(min);

  // This is the "local Pacific wall time" treated as if it were UTC.
  // We'll adjust it by the real Pacific offset next.
  const localAsUTC = Date.UTC(year, month - 1, day, hours, minutes, 0);

  // First guess: assume standard time (-8h = 480 minutes)
  let offsetMinutes = 480;
  let utcMs = localAsUTC + offsetMinutes * 60 * 1000;

  // Refine using actual Pacific rules (DST, etc.)
  offsetMinutes = getTimeZoneOffset(new Date(utcMs), "America/Los_Angeles");
  utcMs = localAsUTC + offsetMinutes * 60 * 1000;

  // This Date represents the correct UTC moment corresponding to the
  // Pacific local time the admin entered.
  return new Date(utcMs);
}

// Parse "MM/DD/YYYY HH:mm" or "MM/DD/YYYY"
function parseSlideTime(dateStr) {
  if (!dateStr) return null;
  const [datePart, timePart] = dateStr.split(" ");
  const [month, day, year] = datePart.split("/").map(Number);
  const [hour = 0, minute = 0] = (timePart ? timePart.split(":") : []).map(Number);

  return new Date(year, month - 1, day, hour, minute);
}

// --- Init slider with scheduling ---
document.addEventListener('DOMContentLoaded', function() {
  var $bar = $('.announcement-bar__slider');
  if (!$bar.length || typeof $.fn.slick !== 'function') return;

  // --- START WITH STORE TIME ---
  const storeTimeAttr = $bar.attr('data-store-time'); // raw string from data attribute
  const storeTimeParts = storeTimeAttr.split(/[-T:]/).map(Number); // [YYYY, MM, DD, hh, mm, ss]
  const storeTimeStart = new Date(
    storeTimeParts[0],       // year
    storeTimeParts[1] - 1,   // month
    storeTimeParts[2],       // day
    storeTimeParts[3],       // hour
    storeTimeParts[4],       // minute
    storeTimeParts[5] || 0   // second
  );
  const pageLoadMs = performance.now();

  function getCurrentStoreTime() {
    return new Date(storeTimeStart.getTime() + (performance.now() - pageLoadMs));
  }

  // Filter out expired/future slides
  $bar.find('.announcement-slide').each(function() {
    const $slide = $(this);
    const restricted = $slide.data('date-restricted') === true || $slide.data('date-restricted') === 'true';
    if (!restricted) return;

    const now = getCurrentStoreTime();
    const start = parseSlideTime($slide.data('start-date'));
    const end = parseSlideTime($slide.data('end-date'));

    if ((start && now < start) || (end && now > end)) {
      $slide.remove();
    }
  });

  // If no valid slides, hide the entire announcement bar
  if ($bar.find('.announcement-slide').length === 0) {
    $bar.closest('.announcement-bar').hide();
    return;
  }

  // Read settings from data attributes
  const autoplay = $bar.data('autoplay') === true || $bar.data('autoplay') === 'true';
  const autoplaySpeed = parseInt($bar.data('autoplay-speed'), 10) * 1000 || 4000;

  // Initialize Slick
  $bar.slick({
    autoplay: true,
    autoplaySpeed: autoplaySpeed,
    arrows: false,
    dots: false,
    infinite: true,
    fade: false,
    speed: 500,
    cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });
});
